<mat-form-field
  [class.ng-invalid]="ngControl?.invalid && (ngControl?.touched || ngControl?.dirty)"
  appearance="outline"
  class="custom_text_input_field cutom_select_input_field"
>
  <input
    type="text"
    [value]="selectedKeysString"
    [required]="field.required"
    (input)="onInputChange($event, field)"
    (keydown.enter)="onEnterKey($event)"
    matInput
    [matAutocomplete]="groupAuto"
    (focus)="focusAutoCompleteInput(field.optionGroups)"
    [class.ng-invalid]="shouldShowError"
    #autocompleteTrigger="matAutocompleteTrigger"
  />
  <mat-label>{{ field.label }}</mat-label>
</mat-form-field>
<mat-autocomplete
  #groupAuto="matAutocomplete"
  [displayWith]="displayFn.bind(this)"
  class="custom_select_box grouped-multiselect"
>
  <ng-container *ngFor="let group of field.optionGroups; let i = index; trackBy: trackByValue">
    <mat-optgroup *ngIf="group?.title">
      <div class="matGroupContainer" (click)="onGroupHeaderClick($event, group, cityLabel)">
        <mat-checkbox
          #cityLabel
          [checked]="isGroupSelected(group)"
          [value]="group.title"
          (click)="$event.stopPropagation()"
          (change)="selectCity($event, group)"
          class="custom_check_box"
          color="primary"
          style="margin-right: 3px"
        >
        </mat-checkbox>
        <span>{{ group.title }}</span>
      </div>
      <ng-container *ngFor="let item of group.fields">
        <mat-option *ngIf="group?.title != 'Select All'" [value]="item.value">
          <div (click)="$event.stopPropagation()">
            <mat-checkbox
              [checked]="isSelected(item)"
              class="custom_check_box"
              color="primary"
              (change)="toggleSelection(item)"
            >
              {{ item.key }}
              <ng-container *ngIf="item?.icons?.length">
                <span *ngFor="let icon of item.icons"> <img [src]="icon" alt="" /></span>
              </ng-container>
            </mat-checkbox>
          </div>
        </mat-option>
      </ng-container>
    </mat-optgroup>
  </ng-container>
</mat-autocomplete>
